import * as React from "react";
import { Component } from "react";

import ReactMapGL, { Marker, Viewport } from "react-map-gl";
import { accessToken } from "../config/mapbox.js";
import markerImage from "../marker.png";

import { ITrailer } from "../App";

interface IProps {
  trailer?: ITrailer;
  onViewportChange?: ((viewport: Viewport) => void) | undefined;
  viewport: Viewport;
  currentMarker: {
    latitude: number;
    longitude: number;
  };
}

const markerSize = 60;

class Map extends Component<IProps> {
  public render() {
    const { trailer, viewport, currentMarker } = this.props;
    return (
      <div style={{ margin: "20px auto", width: "80vw" }}>
        <ReactMapGL
          {...viewport}
          width={window.innerWidth * 0.8}
          height={window.innerHeight * 0.8 - 200}
          mapStyle="mapbox://styles/mapbox/satellite-v9"
          mapboxApiAccessToken={accessToken}
          onViewportChange={this.props.onViewportChange}
        >
          <Marker
            latitude={currentMarker.latitude}
            longitude={currentMarker.longitude}
            offsetTop={(markerSize / 2) * -1}
          >
            {trailer ? (
              <img
                src={markerImage}
                style={{ height: `${markerSize}px`, width: `${markerSize}px` }}
              />
            ) : (
              <div style={{ background: "#eee" }}>
                <h1>Trailer not found.</h1>
              </div>
            )}
          </Marker>
        </ReactMapGL>
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.tsx